import { connect } from 'react-redux';

import { Account } from '@zapier/shared-entities';
import * as Zap from 'app/entities/Zap';
import ZapMoverStatus from 'app/zap-mover/components/ZapMoverStatus';

const mapStateToProps = (state, { fromAccountId, toAccountId }) => {
  const fromAccount = Account.selectors.all.entity(fromAccountId, state);
  const toAccount = Account.selectors.all.entity(toAccountId, state);
  return {
    didTransferToCurrentAccount:
      Account.selectors.all.currentAccountId(state) === toAccountId,
    fromAccountId,
    fromAccountName: Account.selectors.name(fromAccount),
    // If they're still moving, count by entity...
    numZaps:
      Zap.selectors.all.filterBy(Zap.selectors.isSelectedForMoving, state)
        .length ||
      // ...otherwise the entities are gone and `movedCount` has replaced them.
      Zap.selectors.all.movedCount(state),
    status: Zap.selectors.all.movingStatus(state),
    toAccountId,
    toAccountName: Account.selectors.name(toAccount),
  };
};

const mapDispatchToProps = dispatch => ({
  onTryAgain() {
    dispatch(Zap.actions.resetMovingStatus());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ZapMoverStatus);
